import { styled } from "@mui/material"
import Pagination from "@mui/material/Pagination"

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  ".MuiPagination-ul": {
    backgroundColor: "#fff",
    "& .MuiPaginationItem-root": {
      borderRadius: 0,
      margin: 0,
      width: "2rem",
      height: "2rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      "&.Mui-selected": {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        "&::after": {
          content: "''",
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "3px",
          backgroundColor: theme.palette.secondary.main,
        },
      },
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
  },
}))
